import { LadzoConsole as Lc } from "../global/ladzo-console.js";

class ShoptetExtend {
  getTooltip(text) {
    return `<span class="show-tooltip question-tooltip" title="" data-original-title="${text}">?</span>`;
  }
  getSelectedParameters(target) {
    Lc.h("--------");
    Lc.f("ShoptetExtend.getSelectedParameters", target);

    var selector =
      ".variant-list .hidden-split-parameter, .variant-list .split-parameter";
    var $splitParameters = $(selector);

    var parameterValues = [];
    var parameterNames = [];
    var valueIsMissing = false;
    $splitParameters.each(function() {
      let dataParameterId = $(this).attr("data-parameter-id");
      parameterNames.push(dataParameterId);
      let val = $("input:checked, option:selected", this).val();
      if ($.trim(val) === "") {
        valueIsMissing = true;
      }
      parameterValues.push(val);

      Lc.log("pruchod", [dataParameterId, val]);
    });
    if (!valueIsMissing) {
      var tempVariantCode = [];
      for (var i = 0; i < parameterValues.length; i++) {
        tempVariantCode.push(
          String(parameterNames[i]) + "-" + String(parameterValues[i])
        );
      }
      tempVariantCode.sort();
      var variantCode = tempVariantCode.join("-");
      return variantCode;
    }
    return false;
  }
}

var Shpt = new ShoptetExtend();
export { Shpt };
